var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { apiCreateClientOrder, apiGetOneClientRfp, } from '@/actions/ClientRfpActions';
import { FOLLOW_STATUS_EXTERNAL, FOLLOW_STATUS_PROFFIT, FOLLOW_STATUS_SEND_OFF, } from '@/define/consts/rfp/rfp_follow_define';
import { wrapDispatch, wrapNotifyError } from '@/helpers/action';
import { propArrayShape, propShape } from '@/helpers/custom-prop-types';
import { compose } from '@/helpers/recompose';
import { useBoolState, useUnmountRef } from '@/helpers/use/useHook';
import { formatToString } from '@/utils/libs/date-fns/format';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import RfpPageTitle from '../../../Ui/Rfp/RfpPageTitle';
import ClientRfpHoc from '../Hoc/ClientRfpHoc';
import RfpOneArrowLink from './Parts/Head/RfpOneArrowLink';
import OrderComplete from './Parts/Order/OrderComplete';
import OrderCompleteModal from './Parts/Order/OrderCompleteModal';
import OrderForm from './Parts/Order/OrderForm';
import RfpContentSubMenu from './Parts/SubMenu/RfpContentSubMenu';
import RfpOneSkeleton from './RfpOneSkeleton';
import { rfpOneUseCase } from './UseCase/RfpOneUseCase';
/**
 * TODO: TS化 & tailwind化
 */
const RfpOneOrder = (props) => {
    const { offers, rfp } = props;
    const { id, is_end: isEnd, name } = rfp;
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const pans = useMemo(() => [
        {
            link: '/mypage/project',
            text: 'マイページ',
        },
        {
            text: name,
        },
    ], [name]);
    const { isActionDisabled, isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    const interviews = useMemo(() => offers.filter((v) => v.offer.interview_status), [offers]);
    const { boolState: isShow, changeFalse: hideModal, changeTrue: showModal, } = useBoolState();
    const unmountRef = useUnmountRef();
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { select } = values;
            const newValues = {
                finalContractor: null,
                reason: values[`reason_${select}`] || '',
                tentativeEndDate: formatToString({
                    formatString: 'yyyy-MM-dd',
                    value: values[`end_date_${select}`],
                }),
                tentativeStartDate: formatToString({
                    formatString: 'yyyy-MM-dd',
                    value: values[`start_date_${select}`],
                }),
                viewRequestId: null,
            };
            if (select === 'external') {
                newValues.finalContractor = FOLLOW_STATUS_EXTERNAL.value;
            }
            else if (select === 'send_off') {
                newValues.finalContractor = FOLLOW_STATUS_SEND_OFF.value;
            }
            else {
                newValues.finalContractor = FOLLOW_STATUS_PROFFIT.value;
                newValues.viewRequestId = parseInt(select, 10);
            }
            const action = apiCreateClientOrder(id, newValues);
            yield wrapDispatch(dispatch, action);
            yield wrapDispatch(dispatch, apiGetOneClientRfp(id));
            if (!unmountRef.current) {
                showModal();
            }
        }));
    }), [id, dispatch, showModal, unmountRef]);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container rfp_client_one_container is_order' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${name} 発注先を決める｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(RfpPageTitle, { text: name }), _jsx("div", Object.assign({ className: 'rfp_container' }, { children: _jsxs("div", Object.assign({ className: 'rfp_content' }, { children: [_jsxs("div", Object.assign({ className: 'rfp_content_main' }, { children: [_jsx(RfpOneArrowLink, { activeIndex: 3, offers: offers, rfp: rfp }), _jsx("div", Object.assign({ className: 'rfp_content_body' }, { children: isEnd ? (_jsx(OrderComplete, { offers: interviews, rfp: rfp })) : (_jsx(OrderForm, { form: 'rfp_order_form', isDisabled: isActionDisabled, offers: interviews, onSubmit: onSubmit })) }))] })), _jsx(RfpContentSubMenu, { isCanUpdateMember: isCanUpdateMember, isMemberAdmin: isMemberAdmin, members: members, rfp: rfp })] })) })), _jsx(OrderCompleteModal, { hideModal: hideModal, isShow: isShow })] })));
};
RfpOneOrder.propTypes = {
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isCanUseProffit: true,
    isPreClient: false,
    isPreview: true,
}), ClientRfpHoc({
    redirectCallback: ({ offers, rfp }) => {
        const interviews = offers.filter((v) => v.offer.interview_status);
        return interviews.length === 0 ? `/project/client/${rfp.id}/offer` : '';
    },
}, RfpOneSkeleton));
export default enhance(RfpOneOrder);
